import {
  IUbigeoRepository,
  UbigeoEntity,
  ResponseValueObject,
} from '@gishub/domain';
import axios from 'axios';

export class UbigeoRepository implements IUbigeoRepository {
  private readonly baseUrl = 'https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer';
  private readonly DEPT_LAYER = 35;
  private readonly PROV_LAYER = 34;
  private readonly DIST_LAYER = 33;
  static readonly DEFAULT_DEPARTMENT_CODE = '12'; // Junín

  async getDepartments(): Promise<ResponseValueObject<UbigeoEntity[]>> {
    const res = await axios.get(`${this.baseUrl}/${this.DEPT_LAYER}/query`, {
      params: {
        where: "CODDEP IS NOT NULL",
        outFields: 'CODDEP,NOMBDEP',
        orderByFields: 'NOMBDEP ASC',
        f: 'json',
        returnGeometry: false
      }
    })
    const entities: UbigeoEntity[] = (res.data.features || [])
      .map((f: any) => ({
        code: f.attributes.CODDEP,
        name: f.attributes.NOMBDEP,
        parentCode: null
      }))
      .filter((e: UbigeoEntity) => e.code !== null && e.name !== null);
    return new ResponseValueObject(true, entities);
  }

  async getProvincesByDepartment(departmentCode: string): Promise<ResponseValueObject<UbigeoEntity[]>> {
    const res = await axios.get(`${this.baseUrl}/${this.PROV_LAYER}/query`, {
      params: {
        where: `CODDEP = '${departmentCode}'`,
        outFields: 'CODPROV,NOMBPROV',
        orderByFields: 'NOMBPROV ASC',
        f: 'json',
        returnGeometry: false
      }
    })

    const entities: UbigeoEntity[] = (res.data.features || []).map((f: any) => ({
      code: f.attributes.CODPROV,
      name: f.attributes.NOMBPROV,
      parentCode: departmentCode
    }));

    return new ResponseValueObject(true, entities);
  }

  async getDistrictsByProvince(provinceCode: string): Promise<ResponseValueObject<UbigeoEntity[]>> {
    const deptCode = provinceCode.substring(0, 2);
    const provCode = provinceCode.substring(2, 4);
    const res = await axios.get(`${this.baseUrl}/${this.DIST_LAYER}/query`, {
      params: {
        where: `CODPROV = '${provCode}' AND CODDEP = '${deptCode}'`,
        outFields: 'UBIGEO,NOMBDIST,CODPROV,CODDEP',
        orderByFields: 'NOMBDIST ASC',
        f: 'json',
        returnGeometry: false
      }
    })

    const entities: UbigeoEntity[] = (res.data.features || []).map((f: any) => ({
      code: f.attributes.UBIGEO,
      name: f.attributes.NOMBDIST,
      parentCode: f.attributes.CODDEP + f.attributes.CODPROV
    }));

    return new ResponseValueObject(true, entities);
  }

  getDefaultDepartmentCode(): string {
    return UbigeoRepository.DEFAULT_DEPARTMENT_CODE;
  }

  async getDepartmentGeometry(departmentCode: string): Promise<ResponseValueObject<any>> {
    const res = await axios.get(`${this.baseUrl}/${this.DEPT_LAYER}/query`, {
      params: {
        where: `CODDEP = '${departmentCode}'`,
        outFields: '*',
        f: 'json',
        returnGeometry: true
      }
    })
    return new ResponseValueObject(true, res.data);
  }

  async getProvinceGeometry(provinceCode: string): Promise<ResponseValueObject<any>> {
    const res = await axios.get(`${this.baseUrl}/${this.PROV_LAYER}/query`, {
      params: {
        where: `CODPROV = '${provinceCode}'`,
        outFields: '*',
        f: 'json',
        returnGeometry: true
      }
    })
    return new ResponseValueObject(true, res.data);
  }

  async getDistrictGeometry(districtCode: string): Promise<ResponseValueObject<any>> {
    const res = await axios.get(`${this.baseUrl}/${this.DIST_LAYER}/query`, {
      params: {
        where: `UBIGEO = '${districtCode}'`,
        outFields: '*',
        f: 'json',
        returnGeometry: true
      }
    })
    return new ResponseValueObject(true, res.data);
  }
}
